<template>
  <section class="n3-portada" v-if="B">
    <div class="n3-portada__fondo" aria-hidden="true">
      <video v-if="esVideo" :src="media" muted autoplay playsinline loop preload="metadata"></video>
      <img v-else-if="media" :src="media" alt="" fetchpriority="high" :style="{ filter: B.ImagenFiltro || undefined }" />
    </div>
    <div class="n2-contenedor n3-portada__contenido">
      <img v-if="B.Logo && B.ImagenLogo?.trim()" class="n3-portada__logo" :src="imagenIDtoSRC(B.ImagenLogo)" :alt="'Logo de la ' + NOTARIA.Nombre" />
      <h1 class="n3-portada__titulo" v-html="B.Titulo?.Texto || NOTARIA.Nombre"></h1>
      <p v-if="B.Subtitulo?.Texto" class="n3-portada__subtitulo" v-html="B.Subtitulo.Texto"></p>
      <div v-if="B.Texto?.Texto" class="n3-portada__parrafo" v-html="B.Texto.Texto"></div>
      <div class="n3-portada__botones">
        <button v-if="B.ShowButtonMoveMenu && B.ButtonMoveMenu?.Texto" type="button" class="n2-boton n2-boton--acento n2-boton--grande"
          @click="ir(B.ButtonMoveMenu.Click, false)">{{ B.ButtonMoveMenu.Texto }}</button>
        <button v-if="B.ShowButtonMoveInicio && B.ButtonMoveInicio?.Texto" type="button" class="n2-boton n3-boton--cristal n2-boton--grande"
          @click="ir(B.ButtonMoveInicio.Click, true)">{{ B.ButtonMoveInicio.Texto }}</button>
      </div>
    </div>

    <!-- Barra flotante con lo que más se busca: si está abierta, teléfono y dirección -->
    <div class="n2-contenedor n3-portada__pie">
      <div class="n3-barra-cristal">
        <span v-if="abierto !== null" class="n2-estado" :class="abierto ? 'n2-estado--abierto' : 'n2-estado--cerrado'">
          <span class="n2-estado__punto"></span>{{ tSolicitud(abierto ? 'Abierto ahora' : 'Cerrado ahora') }}
        </span>
        <a v-if="C.Telefono" :href="'tel:' + C.Telefono.replace(/\s/g, '')"><v-icon size="18">mdi-phone-outline</v-icon> {{ C.Telefono.trim() }}</a>
        <a v-if="C.Direccion" :href="C.EnlaceMaps || undefined" target="_blank" rel="noopener" class="n3-barra-cristal__dir">
          <v-icon size="18">mdi-map-marker-outline</v-icon> {{ C.Direccion }}<template v-if="C.Municipio">, {{ C.Municipio }}</template>
        </a>
      </div>
      <button type="button" class="n3-portada__bajar" @click="bajar" aria-label="Ver más"><v-icon>mdi-arrow-down</v-icon></button>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { abiertoAhora, useAccionBanner } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, getFile } = useUtils()
const ir = useAccionBanner()

// Panel: Inicio → Banner (mismos textos, imagen o vídeo y botones)
const B = computed(() => NOTARIA.value?.Theme?.Home?.Banner)
const C = computed(() => NOTARIA.value?.Contacto ?? {})
const esVideo = computed(() => getFile(B.value?.Imagen)?.type === 'video/mp4')
const media = computed(() => B.value?.Imagen ? imagenIDtoSRC(B.value.Imagen) : '')

const abierto = ref(null)
onMounted(() => { abierto.value = abiertoAhora(C.value.HorarioEstructurado) })

function bajar() {
  const siguiente = document.querySelector('.n3-portada + *')
  if (siguiente) window.scrollTo({ top: siguiente.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' })
}
</script>
